// extracted by mini-css-extract-plugin
export default {"root":"bkIuWA","loading":"xXaCpo","preloader":"d1WWt1","semi-rotate":"kYZz2Z","semiRotate":"kYZz2Z","inner-rotate":"wlf4P4","innerRotate":"wlf4P4"};